var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ObjectiveSectionLayout",
    {
      scopedSlots: _vm._u([
        {
          key: "icon",
          fn: function() {
            return [
              _c("CompassIcon", {
                attrs: { size: "large", icon: "obj-nb-green-3" }
              })
            ]
          },
          proxy: true
        },
        {
          key: "title",
          fn: function() {
            return [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$l10n.__("Quelles sont vos attentes ?")) +
                  "\n    "
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "objective-result__previous-perform" }, [
        _c("img", {
          attrs: {
            src: "/ressources/logged/img/objectives/objective-result.svg"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "objective-result__previous-perform--amount" },
          [
            _c(
              "span",
              { staticClass: "typographies-paragraph-x-large-semibold amount" },
              [
                _vm.hasPreviousRefinements
                  ? [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                              _vm.previousTotalAmount,
                              {
                                currency: _vm.settings.currency,
                                currencysymbol: _vm.currencySymbol
                              }
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  : [_vm._v(" - ")]
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-small-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__(
                        _vm.hasPreviousRefinements
                          ? "Réalisé en %s"
                          : "Aucune donnée à afficher",
                        _vm.previousYear
                      )
                    ) +
                    "\n            "
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "objective-result__expected-amount" },
        [
          _c(
            "CompassFormItem",
            {
              staticClass: "objective-result__expected-amount--estimation",
              attrs: {
                label: _vm.$t.__(
                  "objectives.create.section.ObjectiveSectionResult.expected_result"
                ),
                error: _vm.errors && _vm.errors.get("turnover.amount")
              }
            },
            [
              _c("AmountInputFormated", {
                attrs: {
                  currencySymbol: _vm.currencySymbol,
                  disabled: _vm.isRefinementsAdjustable,
                  placeholder: _vm.$t.__(
                    "objectives.create.section.ObjectiveSectionResult.enter_expected_amount"
                  ),
                  error: _vm.errors && _vm.errors.has("turnover.amount")
                },
                model: {
                  value: _vm.expectedAmount,
                  callback: function($$v) {
                    _vm.expectedAmount = $$v
                  },
                  expression: "expectedAmount"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.canAdjustRefinements
            ? _c(
                "div",
                { staticClass: "objective-result__expected-amount--buttons" },
                [
                  _c("CompassSwitch", {
                    staticClass:
                      "objective-result__expected-amount--buttons-toggle",
                    attrs: {
                      label: _vm.$t.__(
                        "objectives.create.section.ObjectiveSectionResult.adjust_monthly_payment"
                      ),
                      orientation: "left",
                      disabled: !_vm.enabledSwitchButton
                    },
                    on: {
                      change: function($event) {
                        return _vm.adjustRefinements()
                      }
                    },
                    model: {
                      value: _vm.isRefinementsAdjustable,
                      callback: function($$v) {
                        _vm.isRefinementsAdjustable = $$v
                      },
                      expression: "isRefinementsAdjustable"
                    }
                  }),
                  _vm._v(" "),
                  _vm.hasRefinements
                    ? _c("CompassPlainButton", {
                        staticClass:
                          "objective-result__expected-amount--buttons-edit",
                        attrs: { label: _vm.$t.__("common.actions.edit") },
                        on: {
                          click: function($event) {
                            return _vm.editRefinements()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRefinementsAdjustable && _vm.isRefinementsDisplayed
        ? _c(
            "div",
            {
              staticClass:
                "objective-result__expected-perform typographies-paragraph-medium-regular"
            },
            [
              _c("div", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__(
                        "objectives.create.section.ObjectiveSectionResult.adjusted_expected_result"
                      )
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "objective-result__expected-perform--amounts" },
                [
                  _c(
                    "div",
                    { staticClass: "typographies-paragraph-x-large-semibold" },
                    [
                      _vm.isNewExpectedAmountLoading
                        ? _c("CompassLoader")
                        : _c(
                            "span",
                            {
                              staticClass:
                                "objective-result__expected-perform--amounts-new"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                                      _vm.newExpectedAmount,
                                      {
                                        currency: _vm.settings.currency,
                                        currencysymbol: _vm.currencySymbol
                                      }
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasPreviousRefinements
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "objective-result__expected-perform--amounts-previous typographies-paragraph-small-regular"
                        },
                        [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                                    _vm.previousTotalAmount,
                                    {
                                      currency: _vm.settings.currency,
                                      currencysymbol: _vm.currencySymbol
                                    }
                                  )
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "year" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.previousYear) +
                                "\n                "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.canDisplayRefinements,
              expression: "canDisplayRefinements"
            }
          ],
          ref: "objectiveResultRefinementsCalendar",
          staticClass: "objective-result__refinements-calendar"
        },
        _vm._l(_vm.newRefinements, function(newRefinement) {
          return _c(
            "div",
            {
              key: "refinement-" + newRefinement.label,
              staticClass: "objective-result__refinements-calendar--refinement"
            },
            [
              _c(
                "CompassFormItem",
                { attrs: { label: newRefinement.label } },
                [
                  _c("AmountInputFormated", {
                    attrs: {
                      currencySymbol: _vm.currencySymbol,
                      placeholder: _vm.$t.__(
                        "objectives.create.section.ObjectiveSectionResult.enter_monthly_payment"
                      )
                    },
                    on: {
                      input: function($event) {
                        return _vm.enableNewExpectedAmountLoader()
                      }
                    },
                    model: {
                      value: newRefinement.amount,
                      callback: function($$v) {
                        _vm.$set(newRefinement, "amount", $$v)
                      },
                      expression: "newRefinement.amount"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.canDisplayPreviousObjectiveOfARefinement(newRefinement)
                ? _c(
                    "div",
                    {
                      staticClass:
                        "objective-result__refinements-calendar--refinement-previous typographies-paragraph-small-regular"
                    },
                    [
                      _c("span", { staticClass: "amount" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                                newRefinement.previousObjective.amount,
                                {
                                  currency: _vm.settings.currency,
                                  currencysymbol: _vm.currencySymbol
                                }
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "period" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(newRefinement.previousObjective.period) +
                            "\n                "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.canDisplayRefinements
        ? _c(
            "div",
            { staticClass: "objective-result__buttons" },
            [
              _c("CompassButton", {
                staticClass: "objective-result__buttons--cancel",
                attrs: {
                  label: _vm.$t.__("common.actions.cancel"),
                  type: "secondary",
                  disabled: _vm.isFirstRefinementAdjust
                },
                on: {
                  click: function($event) {
                    return _vm.cancelEditedRefinements()
                  }
                }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "objective-result__buttons--save",
                attrs: { label: _vm.$t.__("common.actions.save") },
                on: {
                  click: function($event) {
                    return _vm.saveRefinements()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }